// imports here
import Dashboard from '../views/dashboard/Index'
import AuthLogin from '../views/auth/AuthLogin'
import apps from './apps'
import blog from './blog'

// define routes
const routes = [
  {
    path: '/',
    name: 'dashboard',
    components: {
      authenticated: Dashboard
    },
    meta: {
      requiredAuth: true
    },
    children: [
      {
        path: 'blog',
        name: 'blog',
        component: () => import(/* webpackChunkName: "blog" */ '../views/dashboard/blog/Index.vue'),
        meta: {
          requiredAuth: true
        },
        children: blog
      },
      {
        path: 'app',
        name: 'application',
        component: () => import(/* webpackChunkName: "apps" */ '../views/dashboard/app/Index.vue'),
        meta: {
          requiredAuth: true
        },
        children: apps
      }
    ]
  },
  {
    path: '/login',
    name: 'auth.login',
    components: {
      guest: AuthLogin
    },
    meta: {
      requiredAuth: false
    }
  }
]

// export default {routes}
export default routes
